module.exports = __webpack_public_path__ + "static/media/Montserrat-ThinItalic.d4ea0992.ttf";